import {
  RegularBenefitVariant,
  RegularGift,
} from '../../../../../../../typings'
import { GiftView as BaseGiftView } from '../../../../../../Gift'
import { ViewProps } from '../../View'

type Props = ViewProps & {
  config: RegularGift
}

export function GiftView(props: Props) {
  const { onEdit, onRemove, config } = props

  const handleEdit = () => onEdit(RegularBenefitVariant.Gift)

  return (
    <BaseGiftView config={config} onEdit={handleEdit} onRemove={onRemove} />
  )
}
